// eslint-disable-next-line no-unused-vars
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { VITE_HPY_BRANDED_URL, VITE_CITI_BRANDED_URL, VITE_CITI_REPORTING_APPLICATION_URL, VITE_GA4_PROPERTY_CITI, VITE_GA4_PROPERTY_GPN, VITE_GA4_PROPERTY_HPY } from 'Constants/appEnvConstants';

const GA4Listener = (props) => {
  const port = (window.location.port) ? `:${window.location.port}` : '';
  const redirectUri =`https://${window.location.hostname}${port}`;
  useEffect(() => {
    /* eslint-disable no-undef */
    const GA4_PROPERTY = getGA4Property(redirectUri);
    /* eslint-disable no-undef */
    ReactGA.initialize(GA4_PROPERTY);
    /* eslint-enable no-undef */
    const sendPageView = (location) => {
      ReactGA.set({ page: location.pathname });
      ReactGA.send(location.pathname);
    };
    sendPageView(props.history.location);
    props.history.listen(sendPageView);
  }, []);
  
  const getGA4Property = (location) => {
    if (location.includes(VITE_CITI_BRANDED_URL) || location.includes(VITE_CITI_REPORTING_APPLICATION_URL)) 
    {
      return VITE_GA4_PROPERTY_CITI;
    }
    else if (location.includes(VITE_HPY_BRANDED_URL))
    {
      return VITE_GA4_PROPERTY_HPY;
    }
    else {
      return VITE_GA4_PROPERTY_GPN;
    }
  }

  return props.children;
};

GA4Listener.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
  ]).isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(GA4Listener);